var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFirebase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 37,
    height: 55,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#21376d",
    d: "M29.856 15.327c.648-.649 1.58-.275 1.727.631l4.7 28.949-16.459 9.179a3.415 3.415 0 0 1-3.329-.001L.185 44.97l29.671-29.643zm-10.77-4.791.088.146 4.57 8.702-4.781 5.199L.636 42.843l-.499.203-.137.137L14.623 15.24l2.633-4.643c.403-.776 1.355-.749 1.83-.061zM6.257.982C6.43-.118 7.759-.369 8.282.614l6.296 11.907L.408 39.413l-.229.447L6.257.982z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirebase);
export default __webpack_public_path__ + "static/media/firebase.645814569729e83c5b9fc087bc817eda.svg";
export { ForwardRef as ReactComponent };